import { CommonGet, CommonPost } from 'src/helpers/HttpClient';
import tokenDecoder from 'src/utils/tokenDecoder';
import moment from 'moment';

export default {
  getAllGroups,
  getAllFactoriesByGroupID,
  getAllRoutesByFactoryID,
  getAllProductsByFactoryID,
  GetCollectionTypeBalanceRateDetails,
  getAllProducts,
  saveCollectionTypeBalanceRate,
  calculateMonthlyBalance,
  rejectCollectionTypeBalanceRate,
  approveCollectionTypeBalanceRate,
  CheckBalanceEstimationExecutionStatus,
  getBalancePaymentEstimation,
  GetBalancePaymentYearMonth
};

async function calculateMonthlyBalance(collectionTypeBalanceRateModel) {
  let model = {
    ...collectionTypeBalanceRateModel,
    createdBy: tokenDecoder.getUserIDFromToken(),
  }
  let response = await CommonPost('/api/RouteWiseBalancePayment/CalculateMonthlyBalanceWithBalanceRate', null, model);
  return response;
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
  let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  let factoryArray = []
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getAllRoutesByFactoryID(factoryID) {
  let response = await CommonGet('/api/Route/GetRoutesByFactoryID', 'factoryID=' + parseInt(factoryID));
  let routeArray = []
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function getAllProductsByFactoryID(factoryID) {
  let response = await CommonGet('/api/Product/GetProductsByFactoryID', 'factoryID=' + parseInt(factoryID));
  let productArray = []
  for (let item of Object.entries(response.data)) {
    productArray[item[1]["productID"]] = item[1]["productName"]
  }
  return productArray;
}

async function getAllProducts(factoryID) {
  let response = await CommonGet('/api/Product/GetProductsByFactoryID', 'factoryID=' + parseInt(factoryID));
  let array = []
  for (let item of Object.entries(response.data)) {
    array[item[1]["productID"]] = item[1]["productName"]
  }
  return array;
}

async function GetCollectionTypeBalanceRateDetails(groupID, factoryID, productID, date) {

  var month = moment(date).format('MM');//date.getUTCMonth() + 1; //months from 1-12 
  var year = moment(date).format('YYYY'); //date.getUTCFullYear()

  const response = await CommonGet('/api/CollectionTypeBalanceRate/GetCollectionTypeBalanceRateDetails',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&productID=" + parseInt(productID)
    + "&applicableMonth=" + month + "&applicableYear=" + year);
  return response.data;
}

async function saveCollectionTypeBalanceRate(data) {
  let model = {
    collectionTypeBalanceRates: data,
    createdBy: tokenDecoder.getUserIDFromToken(),
  }
  const response = await CommonPost('/api/CollectionTypeBalanceRate/SaveCollectionTypeBalanceRate', null, model);
  return response;
}

async function rejectCollectionTypeBalanceRate(data) {
  let model = {
    collectionTypeBalanceRates: data,
    createdBy: tokenDecoder.getUserIDFromToken(),
  }
  const response = await CommonPost('/api/CollectionTypeBalanceRate/RejectCollectionTypeBalanceRate', null, model);
  return response;
}

async function approveCollectionTypeBalanceRate(data) {
  let model = {
    collectionTypeBalanceRates: data,
    createdBy: tokenDecoder.getUserIDFromToken(),
  }
  const response = await CommonPost('/api/CollectionTypeBalanceRate/ApproveCollectionTypeBalanceRate', null, model);
  return response;
}

async function CheckBalanceEstimationExecutionStatus(executionHistoryID) {
  const response = await CommonGet('/api/RouteWiseBalancePayment/CheckBalanceEstimationExecutionStatus',"executionHistoryID=" + parseInt(executionHistoryID));
  return response;
}

async function getBalancePaymentEstimation(collectionTypeBalanceRateModel) {
  let model = {
    ...collectionTypeBalanceRateModel,
    createdBy: tokenDecoder.getUserIDFromToken(),
  }
  let response = await CommonPost('/api/RouteWiseBalancePayment/GetBalancePaymentEstimation', null, model);
  return response;
}

async function GetBalancePaymentYearMonth(groupID, factoryID) {
  let response = await CommonGet('/api/BalancePaymentYearMonth/GetBalancePaymentYearMonth', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
};